import { useFeatureGate } from "@statsig/react-bindings";
import { useAtomValue } from "jotai";
import { participantCountAtom, recordingStateAtom } from "../../video-sdk";
import { aiAssistedPrescriberNotesGate } from "../../statsig/gates";

export function useRecordingControl(
  hasAppointment: boolean = false,
  isPrescriber: boolean = false,
) {
  const recordingState = useAtomValue(recordingStateAtom).value;
  const inSession = !!useAtomValue(participantCountAtom);
  const { value: aiAssistedPrescriberNotesEnabled } = useFeatureGate(
    aiAssistedPrescriberNotesGate,
  );
  const isVisible =
    inSession &&
    hasAppointment &&
    (!isPrescriber || aiAssistedPrescriberNotesEnabled);

  return {
    isVisible,
    recordingState,
  };
}
